import request from '@/utils/request'

// 列表(主数据列表)
export function loadActivitySignInOutInfoListDataApi(data) {
  return request({
    url: 'web/activitySignInOutInfo/listData',
    method: 'post',
    data
  })
}

// 导出
export function loadActivitySignInOutInfoExportDataApi(data) {
  return request({
    url: "web/activitySignInOutInfo/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateActivitySignInOutInfoApi(data) {
  return request({
    url: 'web/activitySignInOutInfo/saveOrUpdate',
    method: 'post',
    data
  })
}

// 查看
export function initActivitySignInOutInfoApi(data) {
  return request({
    url: 'web/activitySignInOutInfo/init',
    method: 'post',
    data
  })
}

// 根据条件条数
export function findCountByConditionApi(data) {
  return request({
    url: 'web/activitySignInOutInfo/findCountByCondition',
    method: 'post',
    data
  })
}

// 根据活动ID查询用户签到签退信息
export function findUserSignInfoBySellIdApi(data) {
  return request({
    url: 'web/activitySignInOutInfo/findUserSignInfoBySellId',
    method: 'post',
    data
  })
}